import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { SmartintegService } from '../../../services/smartinteg.service';
import { Dataset, JoinConfigForm } from '../../../types/smartinteg';
import { TRANSFORMACOES_JOIN, camposDoDataset, novaChave, novoFiltro, previewChave } from './join-config.util';

/**
 * Editor de Recurso.configuracoes.join. Edita o modelo recebido no lugar (mesmo estilo dos demais painéis);
 * quem salva usa montarJoinConfig/validarJoin do join-config.util.
 */
@Component({
  selector: 'app-join-config',
  templateUrl: './join-config.component.html',
  styleUrls: ['./join-config.component.css']
})
export class JoinConfigComponent implements OnChanges {

  @Input() model!: JoinConfigForm;
  @Input() datasets: Dataset[] = [];
  @Input() aba = 'dataset';

  readonly transformacoes = TRANSFORMACOES_JOIN;
  readonly opcoesSemMatch = [
    { label: 'Deixar os campos vazios', value: 'DEIXAR_VAZIO' },
    { label: 'Ignorar o registro (marca IGNORADO)', value: 'IGNORAR' }
  ];
  readonly opcoesModo = [
    { label: 'Campo do registro', value: 'CAMPO' },
    { label: 'Valor fixo', value: 'FIXO' }
  ];

  camposDataset: string[] = [];
  private datasetCarregado: number | null = null;

  constructor(private smartintegService: SmartintegService) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['model'] || changes['datasets']) this.carregarCamposDoDataset();
  }

  get dataset(): Dataset | undefined {
    return this.datasets.find(d => d.id === this.model?.datasetId);
  }

  get preview(): string {
    return previewChave(this.model);
  }

  onDatasetChange(): void {
    this.carregarCamposDoDataset();
  }

  // Os campos do dataset só existem nos registros (jsonb): usa uma amostra para sugerir origem e intervalo
  private carregarCamposDoDataset(): void {
    const ds = this.dataset;
    if (!ds) { this.camposDataset = []; this.datasetCarregado = null; return; }
    if (this.datasetCarregado === ds.id) return;
    this.datasetCarregado = ds.id;
    this.camposDataset = camposDoDataset(ds.camposChave, []);
    this.smartintegService.listarDadosDataset(ds.id, 0, 20).subscribe({
      next: (resp) => {
        if (this.datasetCarregado === ds.id) this.camposDataset = camposDoDataset(ds.camposChave, resp.registros.map(r => r.dados));
      },
      error: () => { /* sem amostra, o campo continua editável à mão */ }
    });
  }

  adicionarChave(): void { this.model.chaves.push(novaChave()); }
  removerChave(i: number): void { this.model.chaves.splice(i, 1); }
  adicionarFiltro(): void { this.model.filtros.push(novoFiltro()); }
  removerFiltro(i: number): void { this.model.filtros.splice(i, 1); }
  adicionarCampo(): void { this.model.campos.push({ origem: '', destino: '' }); }
  removerCampo(i: number): void { this.model.campos.splice(i, 1); }
}
